import React from 'react';
import $ from 'jquery';
import '@progress/kendo-theme-default/dist/all.css';
import { Button } from '@progress/kendo-react-buttons'
import { process } from '@progress/kendo-data-query';
import { Mainfilter } from './Mainfilter.jsx';
import {
    Grid, GridColumn as Column,
    GridColumnMenuFilter, GridToolbar,
    GridColumnMenuCheckboxFilter
} from '@progress/kendo-react-grid';
import { GridPDFExport } from '@progress/kendo-react-pdf';
import { ExcelExport } from '@progress/kendo-react-excel-export';
import Lang from "../../../lang"
// import { IntlProvider, load, LocalizationProvider, loadMessages } from '@progress/kendo-react-intl';
// import esMessages from '../../../lang/tlklang.json';
// import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
// import currencyData from 'cldr-core/supplemental/currencyData.json';
// import weekData from 'cldr-core/supplemental/weekData.json';
// import numbers from 'cldr-numbers-full/main/pt/numbers.json';
// import caGregorian from 'cldr-dates-full/main/pt-PT/ca-gregorian.json';
// import dateFields from 'cldr-dates-full/main/pt-PT/dateFields.json';
// import timeZoneNames from 'cldr-dates-full/main/pt-PT/timeZoneNames.json';
// import currencies from 'cldr-numbers-full/main/pt-PT/currencies.json';
import { TabelAction } from './tableAction.jsx';
import services from '../../../services.js';


// load(
//     likelySubtags,
//     // currencyData,
//     weekData,
//     numbers,
//     currencies,
//     caGregorian,
//     dateFields,
//     timeZoneNames
// );

// loadMessages(esMessages, 'pt-PT');


let list = [];
export class ColumnMenu extends React.Component {
    /*  Para renderizar o conteúdo html da página   */

    render() {
        return (
            <div>
                <GridColumnMenuFilter {...this.props} expanded={true} />
            </div>
        );
    }
}

export class ColumnMenuCheckboxFilter extends React.Component {
    /*  Para renderizar o conteúdo html da página   */

    render() {
        return (
            <div>
                <GridColumnMenuCheckboxFilter {...this.props} data={list} expanded={true} />
            </div>
        );
    }
}
const Defaultstate = {
    take: 100,
    skip: 0,
    group: [],
    exporting: false,
    modulename: "xxx",
    total:0
}

class TlkTableparcel extends React.Component {
    gridPDFExport;
    _export;

      /* Primeiro passo na acomodação da classe */

      constructor(props) {
        super(props);
        this.state = this.createAppState(Defaultstate);
        this.TabelAction = TabelAction({
            rowbuttonAction: this.rowbuttonAction,
            actionbuttons: this.props.actionbuttons,
            deleteFunc: this.props && this.props.deleteFunc && this.props.deleteFunc
        });
    }

    componentDidMount(){

    }

    componentDidUpdate(preProp){
        let dataState = { ...this.state.dataState }
        if (this.props.date !== preProp.date) {
            console.log("OK1");
        if (this.props.tlkState) {
            dataState = { ...this.props.tlkState }
        }
        dataState.total = parseInt(window.localStorage.getItem('table_total'));
        
        let listdata = []
        if(this.props.list) {
            listdata = this.makedata(this.props.list, dataState);
            list = listdata;
        }
        if (listdata.length === 0 && this.props.sendDatatoTlkTable) {
            let json = this.props.sendDatatoTlkTable(dataState)
            if (json) {
                Promise.all([json]).then((values) => {
                    this.dataRecieved(values[0]);
                });
                return null
            }
        }
    //     console.log(listdata);
    //     // listdata = this.getNewListData(listdata)
        this.setState({
            result: process(listdata.slice(0), dataState),
            dataState: dataState,
            completelist: listdata,
            modulename: this.props.modulename,
            // groupfield,
            // sumfields,
            // exporting: false,
            per_col_width: this.getColWidth(dataState),
        });
    }
    }

    export = () => {
        let todownload= this.getOnlyData();
        this.setState({ exporting: true },()=>{
            this._export.save(todownload);
            this.ExportDone()
        });
    }
    exportPDF = () => {
        let todownload= this.getOnlyData();
        this.setState({ exporting: true },()=>{
            services.exportFiles.pdfDownloader(todownload,this.props.columnlist)
            this.ExportDone()
        });
    }
    ExportDone = () => {
        this.setState({ exporting: false });
    }
    getOnlyData=()=>{
        let listarray= [...list]
        let final=[];
        listarray.map((_r,_i)=>{
          if(Object.keys(_r).length > 0)  
            final.push(_r);
        });
        return final;
    }

  



    rowbuttonAction = (action, dataItem) => {
        this.props.ActionPerform(action, dataItem);
    }

    createAppState = (dataState) => {
        //console.log("createAppState" , this.props.modulename)
        let groupfield = [];
        let sumfields = {}

        if (!this.state || this.state.modulename !== this.props.modulename) {
            dataState = Defaultstate
            dataState.group = this.props.groupfield || [];
        }

        let aggregates = this.props.aggregates;
        if (aggregates) {
            const groups = dataState.group;
            if (groups) { groups.map(group => group.aggregates = aggregates); }
            aggregates.map((row, index) => (
                sumfields[row.field] = row
            ))
        }
        let listdata = []
        if (this.state && this.props.sendDatatoTlkTable) {
            listdata = this.state.completelist;
            list = listdata;
        } else if (this.props.list) {
            listdata = this.props.list;
            list = listdata;
        }
        dataState.total =parseInt( window.localStorage.getItem('table_total'));
        if(this.props.sendDatatoTlkTable){
            this.props.sendDatatoTlkTable(dataState)
        }
        return {
            result: process(listdata.slice(0), dataState),
            completelist: listdata,
            dataState: dataState,
            groupfield,
            sumfields,
            per_col_width: this.getColWidth(dataState),
            modulename: this.props.modulename
        };
    }


    getColWidth = (dataState) => {
        let totalCol = this.props.columnlist.length + 1;
        let totalwidth = $(".table-responsive").width();
        let totalGrouping = dataState.group && dataState.group.length > 0 ? dataState.group.length : 0;
        let groupingWidth = totalGrouping * 32;
        let per_Col_width = (totalwidth - 140 - (groupingWidth)) / (totalCol - 1);
        return per_Col_width;
    }

    dataStateChange = (event) => {
        if(this.props.sendDatatoTlkTable){
            this.props.sendDatatoTlkTable(event.data)
        }
        this.setState(this.createAppState(event.data));
    }

    expandChange = (event) => {
        event.dataItem[event.target.props.expandField] = event.value;
        this.setState({
            result: Object.assign({}, this.state.result),
            dataState: this.state.dataState
        });
    }
    cellRender = (tdElement, cellProps) => {
        if (cellProps.rowType === 'groupFooter') {
            let row = this.state.sumfields[cellProps.field]
            if (row) {
                return (
                    <td className="GridsumField">
                        {cellProps.dataItem.aggregates[cellProps.field].sum}
                    </td>
                );
            }
            else {
                if (cellProps.field === "Classe")
                    return (
                        <td className="GridsumField">
                            Total {cellProps.dataItem.field} :
                        </td>
                    );
            }
        }
        else if (cellProps.rowType !== 'groupHeader') {
            if (cellProps.field === "Estado" && (cellProps.dataItem.status === 1 || cellProps.dataItem.status === "1" || cellProps.dataItem.status === "Active" || cellProps.dataItem.status === "active" || cellProps.dataItem.status === "a" ||
                cellProps.dataItem.Estado === "A")) {
                return (
                    <td className="text-active">
                        Ativo
                    </td>
                );
            } else if (cellProps.field === "Estado") {

                return (<td className="text-inactive"> Inativo </td>);
            } else
                if (cellProps.field === "Estado" && (cellProps.dataItem.status === 1 || cellProps.dataItem.status === "1" || cellProps.dataItem.status === "Active" || cellProps.dataItem.status === "active" || cellProps.dataItem.status === "a" ||
                    cellProps.dataItem.status === "A")) {
                    return (
                        <td className="text-active">
                            Ativo
                        </td>
                    );
                } else if (cellProps.field === "Estado") {
                    return (<td className="text-inactive"> Inativo </td>);
                }
                else if (cellProps.field === "Declaração") {
                    if(cellProps.dataItem["Declaração"] === true || cellProps.dataItem["Declaração"] === 1){
                        return (<td > {  "Sim"} </td>)
                    }else if(cellProps.dataItem["Declaração"] === false || cellProps.dataItem["Declaração"] === 0){
                        return (<td > {"Não"} </td>)
                    }else if(cellProps.dataItem["Declaração"] === null){
                        return (<td > {"nd"} </td>)
                    }
                    
                } else if (cellProps.field === "Legislável") {
                    if(cellProps.dataItem["Legislável"] === true || cellProps.dataItem["Legislável"] === 1){
                        return (<td > {  "Sim"} </td>)
                    }else if(cellProps.dataItem["Legislável"] === false || cellProps.dataItem["Legislável"] === 0){
                        return (<td > {"Não"} </td>)
                    }else if(cellProps.dataItem["Legislável"] === null){
                        return (<td > {"nd"} </td>)
                    }
                } else if (cellProps.field === "Classe") {
                    return (<td > {cellProps.dataItem["Classe"] === 1 ? "A" : cellProps.dataItem["Classe"]} </td>);
                }
        }
        if(cellProps.dataItem[cellProps.field] === ""){
            return ( <td >nd</td>)
        }
        return tdElement;
    }

   
    makedata = (data, dataState) => {
        let returnData = [];
        while (returnData.length < (dataState.skip)) {
            returnData.push({});
        }
        data.map((row, index) => {
            returnData.push(row);
        })
        return returnData;
    }

    dataRecieved = (listdata) => {
        if (Array.isArray(listdata)) {
            this.setState({
                result: [],
            });
            list = listdata;
            let newListData = []
            let dataState = { ...this.state.dataState };
            let per_col_width = this.getColWidth(dataState)
            listdata = this.makedata(listdata, dataState);
            console.log("Listdata",listdata,dataState)
            listdata.map(_r => {
                Object.keys(_r).map(_key => {
                    if(_r[_key] === null || _r[_key] === undefined || _r[_key] === ''){
                        _r[_key] = 'nd'
                    }
                    if(_r[_key] === true){
                        _r[_key] = 'Sim'
                    }
                    if(_r[_key] === false){
                        _r[_key] = 'Não'
                    }
                })
                newListData.push(_r)
            })
            let total= window.localStorage.getItem('table_total') ;
            listdata = newListData

            dataState.total = parseInt(total); //|| listdata.length;
           
            console.log("ttotal",dataState.total);
            this.setState({
                dataState,
                result: process(listdata.slice(0), dataState),
                completelist: listdata,
                per_col_width
            });
        }
    }

    /*  Para renderizar o conteúdo html da página   */

    render() {
        const grid = (
            <Grid
                style={{ minHeight: '520px' }}
                sortable={true}
                pageable={{ pageSizes: [5, 10, 20, 100] }}
                groupable={{ footer: 'visible' }}
                resizable={true}
                reorderable={true}
                data={this.state.result}
                {...this.state.dataState}
                onDataStateChange={this.dataStateChange}
                onExpandChange={this.expandChange}
                expandField="expanded"
                cellRender={this.cellRender}
            >
                {
                    !this.props.noExport && this.state.dataState.total > 0 &&
                    <GridToolbar>
                        <Button
                            title="Export PDF"
                            primary={true}
                            className="btn-ivdp-primary mt-3  mr-2 btn-sm float-right"
                            onClick={this.exportPDF}
                            disabled={this.state.exporting}
                        >
                            {"Exportar para Pdf"}
                        </Button>
                        <Button
                            title="Export Excel"
                            primary={true}
                            className="btn-ivdp-primary mt-3 mr-2 btn-sm float-right"
                            onClick={this.export}
                            disabled={this.state.exporting}
                        >
                            {"Exportar para Excel"}
                        </Button>
                    </GridToolbar>
                }

                {
                    this.props.columnlist.map((_row, index) => (
                        !this.props.notFilterColumn[_row.field] ?

                        _row.field && this.props.columnwidth  ?
                            <Column
                                width={_row.field === "Classe" ? 140 : this.state.per_col_width}
                                field={_row.field}
                                key={index}
                                columnMenu={_row.columnMenuType ? ColumnMenuCheckboxFilter : ColumnMenu} 
                                />
                            :
                            <Column
                                field={_row.field} 
                                key={index}
                                columnMenu={_row.columnMenuType ? ColumnMenuCheckboxFilter : ColumnMenu} 
                                />
                        :
                        <Column
                        width={this.state.per_col_width}
                        field={_row.field} 
                        key={index}
                        />

                    ))
                }
                {
                    (!this.props.notAction && !this.state.exporting) && 
                    <Column field={Lang.langCheck.langRequest("Action")} cell={this.TabelAction}
                        width={ this.props.actionColWidth || this.state.per_col_width }
                    />

                }
            </Grid>
        );
        return (
            // <LocalizationProvider language="pt-PT">
            //     <IntlProvider locale="pt-PT" >
            <>
                <>
                    <GridPDFExport
                        ref={pdfExport => this.gridPDFExport = pdfExport}
                        margin="1cm"
                    >
                        {grid}
                    </GridPDFExport>
                    <ExcelExport
                        data={list}
                        ref={exporter => this._export = exporter}
                    >
                        {grid}
                    </ExcelExport>
                {/* </IntlProvider> */}
                </>
                {
                    // this.props.sendDatatoTlkTable &&
                    // <Mainfilter
                    //     dataState={this.state.dataState}
                    //     onDataRecieved={this.dataRecieved}
                    //     sendDatatoTlkTable={(filter) => this.props.sendDatatoTlkTable(filter)}
                    // />

                }
            </>
            // </LocalizationProvider>

        )
    }
}
export default TlkTableparcel;